import React from "react";

export const notFound = () => {
  return (
    <div>
      <h1>ERR: Not Found</h1>
      <p className="lead">
        OOOOPPPPPSSSSS!!!!! ......The page you are looking for does not exist
      </p>
    </div>
  );
};
export default notFound;
